// A 2-Touch pair's follow-up email(s), shown WITH the pair's page build
// (Edward, 2026-10-28: "part of pair one or part of pair two") — on the PM's
// page card and the build team's card for the same build, so both read the
// same thing. Not the optional promotion email (that one precedes a landing
// page and is its own build). Purely presentational.
//
// Props: emails [{label, name, links_to, blocks: [{label, text}]}] (a page
// build's frozen spec.follow_up_emails); renders nothing when empty.
import React from 'react';
import { FONTS, INK, NEUTRAL, RADII } from '../utils/wizardTheme';

export default function CiqFollowUpEmails({ emails }) {
  const list = (emails || []).filter(Boolean);
  if (!list.length) return null;
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
      {list.map((e, i) => (
        <div key={i} style={{ fontFamily: FONTS.body, fontSize: '12.5px', color: INK.primary,
          background: NEUTRAL.band, border: `1px solid ${NEUTRAL.borderSoft}`, borderRadius: RADII.small,
          padding: '10px 12px', lineHeight: 1.5 }}>
          <div style={{ fontWeight: 700 }}>
            {e.label || 'Engagement Phase 2'}: {e.name || 'Follow-up email'}
          </div>
          <div style={{ fontSize: '11.5px', color: INK.secondary, marginBottom: '4px' }}>
            The follow-up email for this pair — build it with the page
            {e.links_to ? <>; its button opens <b>{e.links_to}</b> directly, no form.</> : '.'}
          </div>
          {(e.blocks || []).map((b, bi) => (
            <div key={bi} style={{ margin: '4px 0 4px 8px' }}>
              <span style={{ fontWeight: 600, fontSize: '11.5px', color: INK.secondary }}>{b.label}</span>
              <div style={{ whiteSpace: 'pre-wrap' }}>{b.text}</div>
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}
